import { useCallback, useEffect, useState } from 'react';
import { Status } from '@Components/Base';

import { getCostCenterTypeDict } from '@Store/selectors/dictionarySelector';
import { getModalRecordKey } from '@Store/selectors/modalSelector';
import {
  useGetCostCenterMutation,
  useGetEmpNumberByUserIdQuery,
} from '@Store/api/dictionaryApiSlice';
import { useAppSelector, useStatusFinderByNum } from '@Hooks/index';
import { useGetRequisitionQuery } from '@Features/MaterialRequest/requests/MaterialRequisition/store/api/MaterialRequestApiSlice';

import { findCostCenterType } from '../../../../../utils/finder';

import fieldSource from '../../FieldSource';

import styles from '../view-tab.module.css';

const DetailsTab: React.FC = () => {
  const { findStatus } = useStatusFinderByNum('Material');
  const costCenterTypes = useAppSelector(getCostCenterTypeDict);
  const [costCenter, setCostCenter] = useState<string>('');
  const [getCostCenter] = useGetCostCenterMutation();
  const requestId = useAppSelector(getModalRecordKey);
  const { data } = useGetRequisitionQuery(requestId!, {
    skip: !requestId,
    refetchOnMountOrArgChange: true,
  });

  const createdBy = data?.createdBy;

  const { data: createdUser } = useGetEmpNumberByUserIdQuery(createdBy, {
    skip: !createdBy,
  });

  const getCostCenterItems = useCallback(
    (
      allocationId: string | number,
      compId: string | number,
      ccId: number
    ): Promise<string> => {
      if (createdUser) {
        return getCostCenter({
          allocationId,
          compId,
          empNo: createdUser,
        })
          .unwrap()
          .then((response) => {
            const costCenterName = response.find(
              (item) => item.id === ccId
            )?.name;

            return costCenterName || '';
          });
      }
      return Promise.resolve('');
    },
    [createdUser]
  );

  useEffect(() => {
    if (data) {
      getCostCenterItems(data.ccTypeId, data.compId, data.ccId).then(
        (ccName) => {
          setCostCenter(ccName);
        }
      );
    }
  }, [data, createdUser]);

  if (!data) return null;

  const costCenterTypeDesc = findCostCenterType(
    costCenterTypes,
    data.ccTypeId
  )?.codeDesc;

  return (
    <>
      {fieldSource({
        data,
        costCenterTypeDesc,
        costCenter,
      }).map((item) => (
        <div className={styles.viewItem} key={item.label}>
          <span className={styles.viewItemLabel}>{item.label}</span>
          {item.label === 'Status' ? (
            <Status
              className={styles.viewItemValue}
              text={findStatus(Number(item.value))?.codeDesc || ''}
            />
          ) : (
            <span className={styles.viewItemValue}>{item.value}</span>
          )}
        </div>
      ))}
    </>
  );
};

export default DetailsTab;
